export default __webpack_public_path__ + "static/media/github.5a2d84f8.svg";